export default () => {
  document.addEventListener('turbolinks:load', () => {

    const getParam = (name) => {
      const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.href);
      if (results == null) {
        return null;
      }
      return decodeURI(results[1]) || 0;
    }

    const paginationSelector = document.querySelector('.pagination-per select')
    paginationSelector?.addEventListener('change', (e) => {
      const first_page = location.href.replace(/([?&])page=([^&#]*)/, '$1');
      const per = e.currentTarget.value;

      if (getParam('per')) {
        location.href = first_page.replace(/([?&])per=([^&#]*)/, `$1per=${per}`);
      } else {
        let delim = '&';
        if (!first_page.includes('?')) {
          delim = '?';
        }
        location.href = `${first_page}${delim}per=${per}`;
      }
    });
  });
}
